import { isEditMode } from './helpers';

export default function initAccordion($this, openIcon, closeIcon) {
	const accordionWrapper = $this.find('.accordion__wrapper');

	if (!isEditMode) {
		accordionWrapper.find('.accordion__content:not(:first)').addClass('accordion-live').stop().slideUp();
		accordionWrapper
			.find('.accordion__item:first')
			.addClass('active-item')
			.find('.accordion-icon')
			.removeClass(closeIcon)
			.addClass(openIcon);

		accordionWrapper.on('click', '.accordion__item', function () {
			const $parent = $(this).closest('.accordion__wrapper');
			$parent.find('.accordion__content').stop().slideUp();
			$parent.find('.accordion__item').not(this)
				.removeClass('active-item')
				.find('[data-fa-i2svg]')
				.removeClass(openIcon)
				.addClass(closeIcon);

			$(this)
				.toggleClass('active-item')
				.find('[data-fa-i2svg]')
				.toggleClass(openIcon)
				.toggleClass(closeIcon);

			var nextEl = $(this).next('div');
			nextEl.stop().slideToggle();
		});
	}
}
